import { useForm } from "react-hook-form";
import { Spinner } from "react-bootstrap";
import ControlledForm from "~/shared/form/ControlledForm";
import FieldContext from "~/shared/form/FieldContext";
import FormSection from "~/shared/form/FormSection";
import { AddressFields, EmergencyContactFields, FullNameFields } from "../family/FieldGroups";
import FormResponse from "~/shared/form/FormResponse";
import FormButton from "~/shared/form/FormButton";
import axios from "axios";
import { useState } from "react";
import Chip from "~/shared/Chip";
import useAxiosData from "~/shared/use-axios-data";

export default function ManageAccount() {
    const [editing, setEditing] = useState(false);
    const [programs, status] = useAxiosData(() => axios.get("programs"), []);
    const formHook = useForm({ defaultValues: async () => (await axios.post("staff/load-profile")).data, disabled: !editing });

    function onSuccess(_, form, data) {
        setEditing(false);
        form.reset(data);
        form.reset();
    }

    return (
        <section className="large">
            <ControlledForm hook={formHook} post="staff/update-profile" onSuccess={onSuccess}>
                <div className="flex flex-col gap-3">
                    <FormSection title="Your Programs" heading className="text-start">
                        {status !== "success" ? (
                            <Spinner animation="border" />
                        ) : formHook.getValues("programs")?.map(program => programs.find(p => p._id === program)).map(({ name, url }) => (
                            <Chip key={name} href={url} newTab>{name}</Chip>
                        ))}
                    </FormSection>
                    <FormSection title="Personal Information" heading>
                        <FieldContext id="details">
                            <div className="flex flex-col gap-3">
                            <FormSection row wrap gap={1}>
                                <FullNameFields />
                            </FormSection>
                            <FormSection row wrap gap={1}>
                                <AddressFields />
                            </FormSection>
                            <FormSection row wrap gap={1} title="Emergency Contact" heading>
                                <EmergencyContactFields />
                            </FormSection>
                            </div>
                        </FieldContext>
                    </FormSection>
                </div>
                <FormResponse />
                {editing ? <div className="btn-container mt-4">
                    <FormButton legacy submit>Save</FormButton>
                    <FormButton legacy reset onClick={() => setEditing(false)}>Cancel</FormButton>
                </div> : (
                    <FormButton legacy onClick={() => setEditing(true)} className="mt-4">Edit</FormButton>
                )}
            </ControlledForm>
        </section>
    );
}